import { Button, Grid, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const FooterWrapper = styled(Grid)({
  fontSize: '0.875rem',
  justifyContent: 'center',
});

export const CustomLink = styled(Link)({
  color: '#ffffff',
  textDecoration: 'none',
  whiteSpace: 'nowrap',

  ':hover': {
    textShadow: '0 1px 2px rgb(42 42 42 / 55%)',
  },

  '&.active': {
    textShadow: '0 1px 2px rgb(42 42 42 / 55%)',
  },
});

export const StyledIconButton = styled(Button)({
  minWidth: 0,
  padding: 0,
  '& .MuiButton-startIcon': {
    margin: 0,
  },
});

export const StyledIcon = styled('img')({
  minWidth: '0',
  padding: 0,
  cursor: 'pointer',
  '& .MuiButton-startIcon': {
    margin: 0,
  },
});
